"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _getFetchConfig = _interopRequireDefault(require("./getFetchConfig"));

var _apply = require("./apply");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FetchAPI = /*#__PURE__*/function () {
  function FetchAPI() {
    var _this = this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, FetchAPI);

    _defineProperty(this, "config", {});

    _defineProperty(this, "middlewares", null);

    _defineProperty(this, "checkStatus", null);

    _defineProperty(this, "parseResponse", null);

    _defineProperty(this, "before", null);

    _defineProperty(this, "after", null);

    var options = config.options,
        checkStatus = config.checkStatus,
        parseResponse = config.parseResponse,
        middlewares = config.middlewares,
        before = config.before,
        after = config.after;
    this.setOptions(options);
    this.setCheckStatus(checkStatus);
    this.setParseResponse(parseResponse);
    this.setMiddlewares(middlewares);
    this.setBefore(before);
    this.setAfter(after);
    ['get', 'post', 'form'].forEach(function (method) {
      _this[method] = function (url, data, opts) {
        var _method = method;

        if (method === 'form') {
          opts.defaultFormat = false;
          _method = 'post';
        }

        if (typeof url === 'string') {
          var fetchOptions = _extends({}, opts, {
            method: _method.toUpperCase(),
            url: url,
            data: data
          });

          return _this.fetch(fetchOptions);
        }

        if (_typeof(url) === 'object') {
          var _fetchOptions = _extends(url, opts, {
            method: _method.toUpperCase()
          });

          return _this.fetch(_fetchOptions);
        }

        throw new Error('Params error. Signature (url, data, opts) or (options)');
      };
    });
  }

  _createClass(FetchAPI, [{
    key: "setOptions",
    value: // 设置基本配置
    function setOptions(options) {
      this.config = options;
    } // 设置状态

  }, {
    key: "setCheckStatus",
    value: function setCheckStatus(checkStatus) {
      this.checkStatus = checkStatus;
    } // 设置类型解析

  }, {
    key: "setParseResponse",
    value: function setParseResponse(parseResponse) {
      this.parseResponse = parseResponse;
    } // 设置中间件

  }, {
    key: "setMiddlewares",
    value: function setMiddlewares(middlewares) {
      if (Array.isArray(middlewares)) {
        this.middlewares = middlewares;
      } else {
        this.middlewares = [middlewares];
      }
    } // 请求前执行

  }, {
    key: "setBefore",
    value: function setBefore(hook) {
      this.before = hook;
    } // 请求后执行

  }, {
    key: "setAfter",
    value: function setAfter(hook) {
      this.after = hook;
    }
  }, {
    key: "fetch",
    value: function fetch(config) {
      var _this2 = this;

      var timeout = config.timeout,
          _config$applyCheckSta = config.applyCheckStatus,
          aliasApplyCheckStatus = _config$applyCheckSta === void 0 ? true : _config$applyCheckSta,
          _config$applyParseRes = config.applyParseResponse,
          aliasApplyParseResponse = _config$applyParseRes === void 0 ? true : _config$applyParseRes,
          _config$applyMiddlewa = config.applyMiddleware,
          applyMiddleware = _config$applyMiddlewa === void 0 ? true : _config$applyMiddlewa,
          before = config.before,
          after = config.after,
          success = config.success,
          error = config.error;
      var fetchConfig = (0, _getFetchConfig.default)(config, this.config); // 请求之前处理

      if (typeof before === 'function') {
        before(config, fetchConfig);
      } else if (typeof this.before === 'function') {
        this.before(config, fetchConfig);
      }

      var _promise; // 超时处理，但实际接口请求并不会被中断


      if (timeout && timeout > 0) {
        var abortFn = null;
        var abortPromise = new Promise(function (resolve) {
          abortFn = function abortFn() {
            resolve({
              status: 504,
              statusText: 'TIMEOUT'
            });
          };
        });
        setTimeout(function () {
          return abortFn();
        }, timeout);
        _promise = Promise.race([(0, _isomorphicFetch.default)(fetchConfig.url, fetchConfig.options), abortPromise]);
      } else {
        _promise = (0, _isomorphicFetch.default)(fetchConfig.url, fetchConfig.options);
      } // 添加状态解析


      if (aliasApplyCheckStatus) {
        _promise = _promise.then(this.checkStatus || _apply.applyCheckStatus);
      } // 添加类型解析


      if (aliasApplyParseResponse) {
        _promise = _promise.then(this.parseResponse || _apply.applyParseResponse);
      } // 添加中间件


      if (applyMiddleware && Array.isArray(this.middlewares) && this.middlewares.length) {
        this.middlewares.forEach(function (item) {
          if (typeof item === 'function') {
            _promise = _promise.then(item);
          }
        });
      }

      _promise = _promise.then(function (json) {
        // 请求之后处理
        if (typeof after === 'function') {
          after(config);
        } else if (typeof _this2.after === 'function') {
          _this2.after(config);
        }

        if (typeof success === 'function') {
          success(json);
        }

        return json;
      }, function (reason) {
        // 请求之后处理
        if (typeof after === 'function') {
          after(config);
        } else if (typeof _this2.after === 'function') {
          _this2.after(config);
        }

        if (typeof error === 'function') {
          error(reason);
        }

        return Promise.reject(reason);
      });
      return _promise;
    }
  }]);

  return FetchAPI;
}();

var _default = FetchAPI;
exports.default = _default;